import { useGetAccountQuery } from "@/shared/services";
import { FEATURE_FLAGS, useFeatureFlag } from "@lib/feature-flags";
import moment from "moment";
import {
  ONBOARDING_COHORT_STARTS_AT,
  RELEASE_PROPERTY_DATE,
} from "./constants";

export const isOnboardingCohort = (createdAt?: string): boolean =>
  !!createdAt &&
  !moment(createdAt).isBefore(moment.utc(ONBOARDING_COHORT_STARTS_AT));

export const isAfterFirstViewRelease = (createdAt?: string): boolean =>
  !!createdAt && moment(createdAt).isAfter(moment(RELEASE_PROPERTY_DATE));

/**
 * A Storydoc admin's "Enable onboarding" on the account wins over everything else. Otherwise
 * the new onboarding shows for accounts in the cohort while the PLATFORM_ONBOARDING flag is
 * on for their org. Every onboarding surface, the deck placeholders included, goes through
 * this hook. Flags live only in the editor: dotell-backend creates the onboarding and
 * Made-for-you decks for every account in the cohort once its own onboardingDeck/starterDecks
 * switches are on, so roll the flag out fully before turning those on.
 */
export const useIsOnboardingCohort = (createdAt?: string): boolean => {
  const isFlagOn = useFeatureFlag(FEATURE_FLAGS.PLATFORM_ONBOARDING);
  const { data: account } = useGetAccountQuery();
  if (account?.onboardingEnabled === true) return true;
  return isFlagOn && isOnboardingCohort(createdAt);
};
